import { gql } from "apollo-boost";

export const LEAGUE_CLUB_REL_MERGE = gql`
  mutation LeagueClubRelMerge(
    $seqno: Int
    $league_seqno: Int!
    $club_id: Int!
  ) {
    leagueClubRelMerge(
      leagueData: {
        seqno: $seqno
        leagueSeqno: $league_seqno
        clubId: $club_id
      }
    ) {
      node {
        seqno
        leagueSeqno
        clubId
        league {
          seqno
        }
        club {
          id
          clubName
        }
      }
    }
  }
`;

// Delete current relationship between club and league
export const DELETE_LEAGUE_CLUB_REL = gql`
  mutation LeagueClubRelDelete($seqno: Int!) {
    leagueClubRelDelete(seqno: $seqno) {
      status
    }
  }
`;

// Delete league by leagueSeqno
export const DELETE_LEAGUE = gql`
  mutation LeagueDelete($seqno: Int!) {
    leagueDelete(seqno: $seqno) {
      status
    }
  }
`;

export const LEAGUE_MERGE = gql`
  mutation LeagueMerge(
    $seqno: Int
    $name: String!
    $description: String!
    $logo: String!
    $sport: String!
    $website: String!
    $updateSource: String!
    $params: String
  ) {
    leagueMerge(
      leagueData: {
        seqno: $seqno
        name: $name
        description: $description
        logo: $logo
        sport: $sport
        website: $website
        updateSource: $updateSource
        params: $params
      }
    ) {
      node {
        seqno
        name
        description
        logo
        sport
        website
        updateSource
        params
      }
    }
  }
`;
